<template>
  <div class="source">

    <div tabindex="0" class="el-upload el-upload--text">
      <div class="el-upload-dragger" style="border: none; width: 400px;">
        <i class="el-icon-upload"></i>
        <div class="el-upload__text" style="font-size: 12px;">{{ $t('message.title.emptyTextInAttachment') }}</div>
      </div>
      <!-- <input type="file" name="file" multiple="multiple" class="el-upload__input"> -->
    </div>

  </div>
</template>

<script>
export default {

}
</script>
<style scoped>
.source {
  width: 100%;
  height: 90px;
  /* width: 380px; */
  /* padding: 34px; */
  display: flex;
  justify-content: center;
  align-items: center;
}
/* 
.icon-upload::before {
  content: " \e7c3";
} */

.description {
  display: flex;
  justify-content: center;
  align-items: center;
}

.description p {
  font-size: 12px;
  color: #5e6d82;
  line-height: 1.5em;
}
</style>
<style></style>